import { defineAction } from '~/prix'
import communityUpdateAction from './communityUpdate.action.json' with { type: 'json' }
import { communityObject } from '../communityObject'
import { z } from 'zod'

const communityUpdateDefinition = defineAction({
  ...communityUpdateAction,

  input: communityObject,
  output: z.object({}),
})

export default communityUpdateDefinition
